/* eslint-disable @typescript-eslint/no-explicit-any */
import { type Virtualizer } from "@tanstack/virtual-core";
import { type RefObject } from "react";

export const makeObserveWindowOffset =
  (listContainerRef: RefObject<HTMLDivElement>) =>
  (instance: Virtualizer<Window, any>, cb: (offset: number) => void) => {
    const element = instance.scrollElement;
    if (!element) {
      return;
    }

    const handler = () => {
      const scroll = element[instance.options.horizontal ? "scrollX" : "scrollY"];
      const elementOffset = listContainerRef.current
        ? documentOffset(listContainerRef.current)[instance.options.horizontal ? "left" : "top"]
        : 0;
      const adjustedScroll = Math.max(0, scroll - elementOffset);
      cb(adjustedScroll);
    };
    handler();

    element.addEventListener("scroll", handler, {
      passive: true,
    });

    return () => {
      element.removeEventListener("scroll", handler);
    };
  };

export const makeWindowScrollOffset = (listContainerRef: RefObject<HTMLDivElement>) => {
  let ranOnce = false;
  return <T extends Window>(
    offset: number,
    { adjustments = 0, behavior }: { adjustments?: number; behavior?: ScrollBehavior },
    instance: Virtualizer<T, any>
  ) => {
    if (!ranOnce) {
      ranOnce = true;
      return;
    }
    const elementOffset = listContainerRef.current
      ? documentOffset(listContainerRef.current)[instance.options.horizontal ? "left" : "top"]
      : 0;

    const toOffset = offset + adjustments + elementOffset;

    instance.scrollElement?.scrollTo?.({
      [instance.options.horizontal ? "left" : "top"]: toOffset,
      behavior,
    });
  };
};

function documentOffset(element: HTMLElement) {
  const { left, top } = element.getBoundingClientRect();
  return { top: top + window.scrollY, left: left + window.scrollX };
}
